import { BlueprintType } from '@constants'
import { IAccount, ICountryConfig, IDocument, IInvoice } from '@root/query'
import dayjs from 'dayjs'
import { getVatRate } from '@utils/getVatOptions'

export const defaultValuesForSalesInvoiceDocument = (
  invoice: IInvoice,
  account_trade_receivables_id: number,
  receivablesAccount?: IAccount,
  countryConfig?: ICountryConfig | null
): Partial<IDocument> => {
  const isCreditNote = Boolean(invoice?.is_credit_note_for)
  const rowEntries =
    invoice?.rows.map(row => ({
      ...(row?.account_id ? { account_id: row.account_id } : {}),
      amount: Math.abs(Number((row?.total_amount + row?.total_vat_amount).toFixed(2))),
      vat_code: row?.vat_code,
      vat_rate: row?.vat_rate
    })) || []

  // Credit notes reverse a sales invoice: debit revenue (+ VAT), credit AR
  // as an explicit line so the document is manual, not a purchase.
  if (isCreditNote) {
    const documentDate = invoice?.settlement_date || invoice?.invoicing_date
    const receivableAmount = Number(
      rowEntries.reduce((sum, entry) => sum + entry.amount, 0).toFixed(2)
    )
    return {
      date: documentDate,
      description: `${invoice?.invoice_number} ${invoice?.receiver_info?.name}`,
      contact_id: invoice?.receiver,
      attachment_ids: [invoice?.pdf?.id],
      tag_ids: invoice?.tag_ids || [],
      blueprint_type: BlueprintType.MANUAL,
      blueprint: {
        debet_entries: rowEntries,
        credit_entries: [
          {
            ...(account_trade_receivables_id ? { account_id: account_trade_receivables_id } : {}),
            amount: receivableAmount,
            ...(receivablesAccount
              ? {
                  vat_code: receivablesAccount.default_vat_code,
                  vat_rate: getVatRate(
                    countryConfig,
                    receivablesAccount.default_vat_rate_label,
                    dayjs(documentDate)
                  )
                }
              : {})
          }
        ]
      }
    }
  }

  return {
    date: invoice?.settlement_date || invoice?.invoicing_date,
    description: `${invoice?.invoice_number} ${invoice?.receiver_info?.name}`,
    contact_id: invoice?.receiver,
    attachment_ids: [invoice?.pdf?.id],
    tag_ids: invoice?.tag_ids || [],
    blueprint_type: BlueprintType.SALES,
    blueprint: {
      ...(account_trade_receivables_id ? { debet_account_id: account_trade_receivables_id } : {}),
      credit_entries: rowEntries
    }
  }
}
